import type { DayOfWeek, DayPlan } from '../types/exercise';
import { DAY_LABELS } from '../types/exercise';
import { getPlanForDay } from '../data/plan';

const ORDER: readonly DayOfWeek[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
] as const;

export function getDayOfWeek(date: Date): DayOfWeek {
  // JS getDay(): 0 = Sonntag … 6 = Samstag
  const jsDay = date.getDay();
  const map: Record<number, DayOfWeek> = {
    0: 'sun',
    1: 'mon',
    2: 'tue',
    3: 'wed',
    4: 'thu',
    5: 'fri',
    6: 'sat',
  };
  const result = map[jsDay];
  if (!result) {
    throw new Error(`Unbekannter Wochentag-Index: ${jsDay}`);
  }
  return result;
}

export function getTrainingDay(date: Date): DayPlan {
  return getPlanForDay(getDayOfWeek(date));
}

export interface NextTrainingHint {
  day: DayOfWeek;
  label: string;
  title: string;
}

/**
 * Liefert den naechsten Tag mit kind === 'training' (skippt pilates und recovery).
 */
export function getNextTrainingDay(today: Date): NextTrainingHint {
  const todayKey = getDayOfWeek(today);
  const startIndex = ORDER.indexOf(todayKey);
  for (let offset = 1; offset <= 7; offset += 1) {
    const idx = (startIndex + offset) % ORDER.length;
    const candidate = ORDER[idx];
    if (!candidate) continue;
    const plan = getPlanForDay(candidate);
    if (plan.kind === 'training') {
      return {
        day: candidate,
        label: DAY_LABELS[candidate],
        title: plan.title,
      };
    }
  }
  throw new Error('Kein Trainingstag im Plan gefunden');
}
